import React from "react";

const Footer = () => {
    return (
        <footer class="bg-primary-dark text-gray-300 py-8">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center sm:flex sm:justify-between sm:items-center">
                <div class="mb-4 sm:mb-0">
                    &copy; 2025 Desi Hauler. All rights reserved.
                </div>
                <div class="flex justify-center space-x-6">
                    <a href="#" class="hover:text-white transition duration-300">Privacy Policy</a>
                    <a href="#" class="hover:text-white transition duration-300">Terms of Service</a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;                                                         